export function getDayRange(dayFrom) {
    const actualDate = new Date()
    const dateFrom = new Date()
    dateFrom.setDate(dateFrom.getDate() - dayFrom)
    return [dateFrom, actualDate]
}

export function getMonthRange(monthFrom) {
    const actualDate = new Date()
    const dateFrom = new Date()
    dateFrom.setMonth(dateFrom.getMonth() - monthFrom)
    return [dateFrom, actualDate]
}

export function getActualMonth() {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return [firstDay, lastDay]
}

export function getPastMonth() {
    const [dateFrom] = getMonthRange(1);
    const firstDay = new Date(dateFrom.getFullYear(), dateFrom.getMonth(), 1);
    const lastDay = new Date(dateFrom.getFullYear(), dateFrom.getMonth() + 1, 0);
    return [firstDay, lastDay]
}
